<div class="top-section">
    <h6 class="heading mb-0">{{ ss.texts()['commonJournalEntries_titleTopBar'] }}</h6>
    <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
</div>
<div class="body-section">
    <cdk-virtual-scroll-viewport class="viewport" #viewport [itemSize]="88">
        <div class="journal-block ri-p-4 ri-bb-1" *cdkVirtualFor="let dateString of entitiyRepeatDates();let i = index; trackBy: trackByDateString;">
            @if (journalBlockComponent) {
                <ng-container *ngComponentOutlet="journalBlockComponent; inputs: getJournalBlockInputs(dateString)"></ng-container>
            }
        </div>
    </cdk-virtual-scroll-viewport>
    <p class="text-14-400 color-7 mb-0 ri-pt-4 ri-px-4 text-end" *ngIf="isDeleted()">{{ deletedAtString() }}</p>
</div>